/* Goodword mobile menu: opens a panel from the right; rows with a caret open in place (accordion). */
class GwDrawer extends HTMLElement {
  connectedCallback() {
    this.openBtn = this.querySelector('.gw-drawer__open');
    this.panel = this.querySelector('.gw-drawer__panel');
    this.overlay = this.querySelector('.gw-drawer__overlay');
    this.openBtn.addEventListener('click', () => this.open());
    this.overlay.addEventListener('click', () => this.close());
    this.querySelector('.gw-drawer__close').addEventListener('click', () => this.close());
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    this.panel.addEventListener('click', (e) => {
      const t = e.target.closest('.gw-mnav__toggle');
      if (!t) return;
      const li = t.closest('.gw-mnav__item');
      const open = li.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // desktop widths use the hover menu, so make sure the panel can't stay open after a resize
    window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => { if (m.matches) this.close(); });
  }

  open() {
    this.panel.hidden = false;
    this.overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => this.classList.add('is-open')); // lets the slide-in play
    this.openBtn.setAttribute('aria-expanded', 'true');
    this.querySelector('.gw-drawer__close').focus();
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    this.openBtn.setAttribute('aria-expanded', 'false');
    setTimeout(() => { if (!this.classList.contains('is-open')) { this.panel.hidden = true; this.overlay.hidden = true; } }, 300);
    this.openBtn.focus();
  }
}
customElements.define('gw-drawer', GwDrawer);
